function initVideoControls() {
    const cards = document.querySelectorAll('.video-moto-card__inner');
    cards.forEach(card => {
        const video = card.querySelector('video');
        const playBtn = card.querySelector('.video-moto-play-btn');
        const volumeBtn = card.querySelector('.video-moto-volume-btn');

        if (video && playBtn) {
            // Sync initial state if video is autoplaying
            if (!video.paused) {
                playBtn.classList.add('is-active');
                playBtn.querySelector('.icon-play').style.display = 'none';
                playBtn.querySelector('.icon-pause').style.display = 'block';
            }

            // Card click to show controls if playing
            card.addEventListener('click', () => {
                if (!video.paused) {
                    card.classList.toggle('show-controls');
                }
            });

            playBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (video.paused) {
                    video.play();
                    playBtn.classList.add('is-active');
                    playBtn.querySelector('.icon-play').style.display = 'none';
                    playBtn.querySelector('.icon-pause').style.display = 'block';
                    card.classList.remove('show-controls');
                } else {
                    video.pause();
                    playBtn.classList.remove('is-active');
                    playBtn.querySelector('.icon-play').style.display = 'block';
                    playBtn.querySelector('.icon-pause').style.display = 'none';
                    card.classList.remove('show-controls');
                }
            });
        }

        if (video && volumeBtn) {
            volumeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                video.muted = !video.muted;
                if (video.muted) {
                    volumeBtn.querySelector('.icon-volume-on').style.display = 'none';
                    volumeBtn.querySelector('.icon-volume-off').style.display = 'block';
                } else {
                    volumeBtn.querySelector('.icon-volume-on').style.display = 'block';
                    volumeBtn.querySelector('.icon-volume-off').style.display = 'none';
                }
            });
        }
    });
}

/* openVideoModal and closeVideoModal removed */

// Determine if mobile viewport
function isMobileViewport() {
    return window.innerWidth <= 600;
}

// Track active Flickity instances for cleanup
const flickityInstances = new Map();

// Initialize Flickity with responsive config
function initFlickity() {
    const carousels = document.querySelectorAll('.video-moto-carousel');
    carousels.forEach(carousel => {
        if (typeof Flickity === 'undefined') return;

        // Destroy existing instance if present (for reinit on resize)
        if (flickityInstances.has(carousel)) {
            flickityInstances.get(carousel).destroy();
            flickityInstances.delete(carousel);
        }

        // Pick config based on viewport
        const isMobile = isMobileViewport();
        const configAttr = isMobile ? 'data-flickity-mobile' : 'data-flickity-config';
        const configStr = carousel.getAttribute(configAttr) || carousel.getAttribute('data-flickity-config');

        let config = {};
        try {
            config = JSON.parse(configStr || '{}');
        } catch (e) {
            console.error('Flickity config error:', e);
        }

        const flkty = new Flickity(carousel, config);
        flickityInstances.set(carousel, flkty);

        // Hide arrows and dots if not scrollable (only one slide)
        const checkScrollable = () => {
            if (flkty.slides.length <= 1) {
                carousel.classList.add('is-not-scrollable');
            } else {
                carousel.classList.remove('is-not-scrollable');
            }
        };

        flkty.on('ready', checkScrollable);
        flkty.on('resize', checkScrollable);
        checkScrollable();

        // Force a resize after init to ensure cards are positioned
        setTimeout(() => {
            flkty.resize();
        }, 200);
    });
}

// Debounce helper
let resizeTimer;
function debouncedReinit() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        initFlickity();
    }, 250);
}

document.addEventListener('DOMContentLoaded', () => {
    initFlickity();
    initVideoControls();
});

// Re-initialize Flickity when inside Shopify Theme Editor
document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('section-video-moto') || event.target.querySelector('.video-moto-carousel')) {
        initFlickity();
        initVideoControls();
    }
});

// Handle window resize — reinit Flickity to swap mobile/desktop config
let lastWasMobile = isMobileViewport();
window.addEventListener('resize', () => {
    const nowMobile = isMobileViewport();
    if (nowMobile !== lastWasMobile) {
        lastWasMobile = nowMobile;
        debouncedReinit();
    }
});
